var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "item-footer" }, [
    _c("div", { staticClass: "price" }, [
      this.data.priceFormatted
        ? _c("p", [
            _vm._v(
              _vm._s(this.$parent.priceFrom) +
                " " +
                _vm._s(this.data.priceFormatted)
            ),
          ])
        : _c("p"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "action" },
      [
        _vm._t("default", function () {
          return [_vm._v("Drück mich!")]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }